import React from "react";
import { Route, Redirect } from "react-router-dom";
import { HomePage } from "../pages/HomePage/HomePage";
import { routeProps } from "../../types/RouteProps";
import NotAuthorized from "../components/Common/NotAuthorized";

function PublicRoutes(props: routeProps) {
  var returnRoutes: any[] = [];

  returnRoutes.push(
    <Route exact path="/" key="root">
      <HomePage />
    </Route>
  );
  returnRoutes.push(
    <Route
      exact
      path="/PageNotAuthorized"
      component={NotAuthorized}
      key="notAuthorized"
    />
  );

  /* This is the default catch-all route and must be last in list.
  DO NOT place your route below this, or it will not be recognized.*/
  returnRoutes.push(
    <Route key="default">
      <Redirect to="/" />
    </Route>
  );

  return returnRoutes;
}

export default PublicRoutes;
